<!-- standard payment form -->
<form #form="ngForm" name="formPayment" id="adyen-encrypted-form" ng novalidate>
  <div *ngIf="price.totalPrice?.majorAmount > 0 && !payByInvoice && !overridePayment && bookingAmendType !== 'refund'">

    <div class="payment_head">

      <!-- <div class="custom-payment-option-tabs">
        <button class="payment-button active margin-bottom-16">
          <img src="../../../../../images/standard-pay-icon.svg" height="25" alt="" />
        </button>

        <app-apple-pay [price]="price" >
        </app-apple-pay>
      </div> -->

    </div>
    <!-- <div *ngIf="paymenttype == 0">
      <app-google-pay [price]="price" [oldprice]="oldprice"></app-google-pay>
        <p id="googlepayValidation" name="googlepayValidation">Please use google pay button for your payment</p>
        <p id="googlepayRefile" name="googlepayRefile">You have update booking details please use google pay again.</p>
    </div> -->
      <div class="panel paymentScreen new-card">
          <h5 class="text-dark-blue margin-top-0">{{appCopy.panelHeader['paymentHeadTitle'+selectedLanguage]}}</h5>
          <div class="flex-lg flex-md">
            <div class="flex__item--grow">

              <div class="form-group">
                <input class="form-control form-control--no-label"
                  [ngClass]="{ 'has-error' : CardNumber.dirty && CardNumber.invalid }" name="ccnumber" id="ccnumber"
                  type="text" autocomplete="cc-number" maxlength="23" data-encrypted-name="number" #CardNumber="ngModel"
                  [ngModel]='formValues.ccnumber' required appFormatCard appCheckEmpty>
                  <label class="control-label"
                for="ccnumber">{{appCopy.panelHeader['ccNumberLabel'+selectedLanguage]}}</label>
                <i class="icon control-validation-state"></i>

                <p class="help-block text-danger" *ngIf="CardNumber.dirty && CardNumber.invalid">
                  {{appCopy.panelHeader['errortextCcNumber'+selectedLanguage]}}</p>
              </div>
            </div>
          </div>
          <div class="flex-lg flex-md">
            <div class="flex__item--grow">

              <div class="form-group">
                <input class="form-control" [ngClass]="{ 'has-error' : CardName.dirty && CardName.invalid }"
                id="nameoncard" name="nameoncard" type="text" autocomplete="cc-name" data-encrypted-name="holderName"
                #CardName="ngModel" [ngModel]='formValues.nameoncard' required appCheckEmpty>
                <label class="control-label"
                  for="nameoncard">{{appCopy.panelHeader['nameOnCardLabel'+selectedLanguage]}}</label>

                <i class="icon control-validation-state"></i>

                <p class="help-block text-danger" *ngIf="CardName.dirty && CardName.invalid">
                  {{appCopy.panelHeader['errorTextNameOnCardRequired'+selectedLanguage]}}
                </p>
              </div>

            </div>
          </div>

          <div class="flex-lg flex-md card-inputs clearfix">
              <div class="form-group">
                <div class="date-inputs">
                  <input class="form-control noSpaces"
                    [ngClass]="{ 'has-error' : CardExpiryMonth.dirty && CardExpiryMonth.invalid || CardExpiryYear.dirty && CardExpiryYear.invalid }"
                    name="ccexpmonth" id="ccexpmonth" type="number" autocomplete="cc-exp-month" maxlength="2"
                    data-encrypted-name="expiryMonth" placeholder="MM" #CardExpiryMonth="ngModel"
                    [pattern]="expiryMonthPattern" [ngModel]='formValues.ccexpmonth' required [appAutoTab]="2">
                    <label class="control-label"
                    for="ccexpmonth">{{appCopy.panelHeader['ccExpMonthLabel'+selectedLanguage]}}</label>
                  <div class="date-inputs__separator"></div>
                  <input class="form-control noSpaces"
                    [ngClass]="{ 'has-error' : CardExpiryMonth.dirty && CardExpiryMonth.invalid || CardExpiryYear.dirty && CardExpiryYear.invalid }"
                    name="ccexpyear" id="ccexpyear" type="number" autocomplete="cc-exp-year" maxlength="2"
                    data-encrypted-name="expiryYear"
                    [placeholder]="appCopy.panelHeader['yearPlaceholder'+selectedLanguage]" #CardExpiryYear="ngModel"
                    [pattern]="expiryYearPattern" [ngModel]='formValues.ccexpyear' required appCheckEmpty>

                  <i class="icon control-validation-state"></i>
                </div>
                <p class="help-block text-danger"
                  *ngIf="CardExpiryMonth.dirty && CardExpiryMonth.invalid || CardExpiryYear.dirty && CardExpiryYear.invalid">
                  {{appCopy.panelHeader['errorTextCcExpMonthLabel'+selectedLanguage]}}</p>
              </div>
              <div class="form-group">
                <input class="form-control noSpaces"
                  [ngClass]="{ 'has-error' : CardSecurityCode.dirty && CardSecurityCode.invalid }" name="CardSecurityCode"
                  id="CardSecurityCode" type="text" maxlength="4" autocomplete="nope" data-encrypted-name="cvc"
                  #CardSecurityCode="ngModel" [pattern]="cardSecurityPattern" [ngModel]='formValues.CardSecurityCode' required appCheckEmpty>
                <label class="control-label"
                  for="CardSecurityCode">{{appCopy.panelHeader['cardSecurityCodeLabel'+selectedLanguage]}}</label>
                <i class="icon control-validation-state"></i>
                <p class="help-block text-danger"
                  *ngIf="CardSecurityCode.dirty && CardSecurityCode.invalid && !CardSecurityCode.errors?.pattern">
                  {{appCopy.panelHeader['errorTextCardSecurityCodeRequired'+selectedLanguage]}}</p>
                <p class="help-block text-danger" *ngIf="CardSecurityCode.dirty && CardSecurityCode.errors?.pattern">
                  {{appCopy.panelHeader['errorTextCardSecurityCodeInvalid'+selectedLanguage]}}</p>
              </div>
          </div>

          <input type="hidden" value="generate-this-server-side" data-encrypted-name="generationtime">

          <p class="help-block text-danger" *ngIf="paymentError">
            {{appCopy.panelHeader['errortextPaymentError'+selectedLanguage]}}</p>

          <div class="checkbox checkbox--default checkbox--small margin-bottom-8"
            *ngIf="userLoggedIn && bookingType !== 'amend'">
            <input type="checkbox" (change)="clickSaveCard($event)" name="saveCard" id="saveCard" #saveCard="ngModel"
              [ngModel]="true">
            <label for="saveCard">{{appCopy.panelHeader['saveCardCheckLabel'+selectedLanguage]}}</label>
          </div>
          <div class="accepted-cards">
            <p class="text-caption text-muted margin-bottom-8">{{appCopy.panelHeader['weAcceptLabel'+selectedLanguage]}}</p>
            <ul class="list-unstyled flex-always">
              <li class="margin-right-8"><i class="sprite-common sprite-common--cards-visa display-block"></i></li>
              <li class="margin-right-8"><i class="sprite-common sprite-common--cards-mastercard display-block"></i></li>
              <li class="margin-right-8"><i class="sprite-common sprite-common--cards-amex display-block"></i></li>
              <li><i class="sprite-common sprite-common--ssl display-block"></i></li>
            </ul>
          </div>
      </div>


      <div class="panel paymentScreen new-card">
          <div class="row" *ngIf="!isCustomerSupport">
            <div class="col-sm-12">
              <h5 class="margin-top-0">{{appCopy.panelHeader['billingAddressLabel'+selectedLanguage]}}</h5>
              <div *ngIf="billingAddress" class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
                <input type="checkbox" name="hasBillingAddress" id="hasBillingAddress" [checked]="hasBillingAddress"
                  (change)="toggleBillingAddress()" required>
                <label for="hasBillingAddress" class="text-caption">
                  <div>
                    <span
                      *ngIf="billingAddressSame">{{appCopy.panelHeader['helperTextBillingAddressSame'+selectedLanguage]}}<br></span>
                    <strong>
                      {{ billingAddress.houseNumberOrName }}, {{ billingAddress.street }}, {{ billingAddress.city }}, {{
                      billingAddress.postalCode }}
                    </strong>
                  </div>
                </label>
              </div>
              <div *ngIf="!hasBillingAddress">
                <app-billing-address #billingAddressForm [billingAddressValid]="billingAddressValid" [appCopy]="appCopy"
                  [selectedLanguage]='selectedLanguage' [formData]='formValues.billingFormData'>
                </app-billing-address>
              </div>
            </div>
          </div>
      </div>

  </div>
</form>
